/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-03 10:33:10
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import Http from './core';

// const baseUrlMap = {
//   develop: 'https://dev-payment.arnoo.com/login',
//   test: 'https://test-eu-m071-aidot-payment.arnoo.com',
//   pre: 'https://pre-eu-m071-aidot-payment.arnoo.com',
//   master: '',
// };

const http = new Http();

http.setOptions({
  // baseURL: baseUrlMap.test || baseUrlMap.master,
  baseURL: process.env.REACT_APP_ROUTE_BASE_NAME,
});

export default http;
